import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const OptGroupLabel = ({ children, nested = false }) => {
  return (
    <span
      className={cn({
        [styles.optGroup]: !nested,
        [styles.nestedOptGroup]: nested,
      })}
    >
      {children}
    </span>
  );
};

export default OptGroupLabel;
